// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pen-ball"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M14.5 5L19 9.5L7.5 21L3.00049 21.0006L3.00049 16.5L14.5 5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 2.5L21.5 7M14.5 5L19 9.5L7.5 21L3.00049 21.0006L3.00049 16.5L14.5 5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.5 12L15.5 18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PenBallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-ball',
    ref,
    icon: element,
  },
));

PenBallIcon.displayName = 'PenBallIcon';

export default PenBallIcon;
